<div class="content-loaf">
  <h2>会員専用ログイン</h2>
  <hr />
  <form *ngIf="formResetToggle" class="content-block login-form" #f="ngForm" novalidate
        (ngSubmit)="f.form.valid ? login() :
                          (!userid.valid && showErrorAlert('ユーザーIDは必須です。', '有効なユーザーIDを入力してください。'));
                          (!password.valid && showErrorAlert('パスワードは必須です。', '有効なパスワードを入力してください。'))">
    <table>
      <tr>
        <td class="text-bold" style="min-width: 90px;">ユーザーID</td>
        <td>
          <div [ngClass]="{'has-success': f.submitted && userid.valid, 'has-error' : f.submitted && !userid.valid}">
            <input type="text" id="login-userid" name="userid" class="form-control" [(ngModel)]="userLogin.userid" #userid="ngModel" required />
            <span class="errorMessage" *ngIf="f.submitted && !userid.valid">
              ユーザーIDは必須です。
            </span>
          </div>
        </td>
      </tr>

      <tr>
        <td class="text-bold">パスワード</td>
        <td>
          <div [ngClass]="{'has-success': f.submitted && password.valid, 'has-error' : f.submitted && !password.valid}">
            <input type="password" id="login-password" name="password" class="form-control" [(ngModel)]="userLogin.password" #password="ngModel" required />
            <span class="errorMessage" *ngIf="f.submitted && !password.valid">
              パスワードは必須です。
            </span>
          </div>
        </td>
      </tr>

      <tr>
        <td></td>
        <td class="text-right">
          <i *ngIf="isLoading" class='fa fa-circle-o-notch fa-spin'></i> <button type="submit" class="btn btn-primary btn-primary-gradient" [disabled]="isLoading">ログイン</button>
        </td>
      </tr>
    </table>
  </form>

</div>
